import type { ComponentType } from 'react';
import {
  FiAlertCircle,
  FiArchive,
  FiArrowLeft,
  FiArrowUp,
  FiBookOpen,
  FiCheck,
  FiCheckCircle,
  FiChevronDown,
  FiChevronRight,
  FiCode,
  FiCopy,
  FiCreditCard,
  FiDownload,
  FiEdit,
  FiEdit2,
  FiFile,
  FiFileText,
  FiFolder,
  FiFolderPlus,
  FiGitBranch,
  FiGithub,
  FiGrid,
  FiLayers,
  FiLink,
  FiLock,
  FiLogOut,
  FiMail,
  FiMessageSquare,
  FiMinus,
  FiMoreHorizontal,
  FiPaperclip,
  FiPlus,
  FiRepeat,
  FiSettings,
  FiShield,
  FiSidebar,
  FiSlash,
  FiSquare,
  FiTag,
  FiTarget,
  FiTool,
  FiTrash2,
  FiX,
  FiZap
} from 'react-icons/fi';
import { RiAnthropicFill, RiOpenaiFill, RiZhipuAiFill } from 'react-icons/ri';

type AppIconComponent = ComponentType<{ 'aria-hidden'?: boolean; className?: string }>;

const asIcon = (icon: unknown): AppIconComponent => icon as AppIconComponent;

export const IconAlert = asIcon(FiAlertCircle);
export const IconArchive = asIcon(FiArchive);
export const IconAnthropic = asIcon(RiAnthropicFill);
export const IconOpenAI = asIcon(RiOpenaiFill);
export const IconZhipu = asIcon(RiZhipuAiFill);
export const IconArrowLeft = asIcon(FiArrowLeft);
export const IconArrowUp = asIcon(FiArrowUp);
export const IconBranch = asIcon(FiGitBranch);
export const IconContext = asIcon(FiBookOpen);
export const IconCheck = asIcon(FiCheck);
export const IconCheckCircle = asIcon(FiCheckCircle);
export const IconClose = asIcon(FiX);
export const IconDismiss = asIcon(FiSlash);
export const IconFix = asIcon(FiTool);
export const IconChevronDown = asIcon(FiChevronDown);
export const IconChevronRight = asIcon(FiChevronRight);
export const IconCard = asIcon(FiCreditCard);
export const IconCode = asIcon(FiCode);
export const IconCopy = asIcon(FiCopy);
export const IconCompose = asIcon(FiEdit);
export const IconDownload = asIcon(FiDownload);
export const IconRename = asIcon(FiEdit2);
export const IconFile = asIcon(FiFile);
export const IconFileText = asIcon(FiFileText);
export const IconFolder = asIcon(FiFolder);
export const IconFolderPlus = asIcon(FiFolderPlus);
export const IconGithub = asIcon(FiGithub);
export const IconGrid = asIcon(FiGrid);
export const IconLink = asIcon(FiLink);
export const IconLock = asIcon(FiLock);
export const IconLogOut = asIcon(FiLogOut);
export const IconMail = asIcon(FiMail);
export const IconChat = asIcon(FiMessageSquare);
export const IconMinus = asIcon(FiMinus);
export const IconMore = asIcon(FiMoreHorizontal);
export const IconPaperclip = asIcon(FiPaperclip);
export const IconPlus = asIcon(FiPlus);
export const IconIssues = asIcon(FiShield);
export const IconRepeat = asIcon(FiRepeat);
export const IconScope = asIcon(FiTarget);
export const IconSettings = asIcon(FiSettings);
export const IconSidebar = asIcon(FiSidebar);
export const IconStop = asIcon(FiSquare);
export const IconTag = asIcon(FiTag);
export const IconTrash = asIcon(FiTrash2);
export const IconWorkflow = asIcon(FiLayers);
export const IconZap = asIcon(FiZap);
